
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M-.31 0v34.25H34V0zm27 13.18A13.34 13.34 0 016.12 25a9.48 9.48 0 007-1.94 4.68 4.68 0 01-4.38-3.25 4.66 4.66 0 002.11-.08A4.69 4.69 0 017 15.09a4.63 4.63 0 002.12.58 4.69 4.69 0 01-1.41-6.25 13.35 13.35 0 009.68 4.89 4.7 4.7 0 018-4.27 9.25 9.25 0 003-1.13 4.7 4.7 0 01-2.09 2.59 9.39 9.39 0 002.7-.74 9.48 9.48 0 01-2.35 2.42z"}})])
          )
        }
      }
    